module.exports = __webpack_public_path__ + "static/media/logo-wfois.e461113e.svg";